import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setAbroadCounselingServices,
  setTestPrepServices,
  setCareerCounselingServices,
  setOtherServices,
  setProfileBuildingServices,
  setServices,
} from "../../../state/reducers/servicesSlice";
import {
  getAbroadCounselingServices,
  getTestPreparationServices,
  getCareerCounselingServices,
  getOtherServices,
  getProfileBuildingServices,
  createProfileBuildingService,
  createOtherService,
  createCareerCounselingService,
  createTestPreparationService,
  createAbroadCounselingService,
  deleteAbroadCounselingService,
  deleteTestPreparationService,
  deleteCareerCounselingService,
  deleteOtherService,
  deleteProfileBulldingService,
} from "../../../services/user.services";
import AbroadTable from "./AbroadTable";
import TestPrepTable from "./TestPrepTable";
import CareerCounselingTable from "./CareerCounselingTable";
import OtherServicesTable from "./OtherServicesTable";
import ProfileBuildingTable from "./ProfileBuildingTable";
import { getNewTable } from "../../../services/mainServices.services";
import { FaChevronDown, FaPlus } from "react-icons/fa";

const ServicesTab = () => {
  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);
  const abroad_counseling_list = useSelector(
    (state) => state.service.abroad_counseling_list
  );
  const test_prep_list = useSelector((state) => state.service.test_prep_list);
  const career_counseling_list = useSelector(
    (state) => state.service.career_counseling_list
  );
  const other_services_list = useSelector(
    (state) => state.service.other_services_list
  );
  const profile_building_list = useSelector(
    (state) => state.service.profile_building_list
  );

  const [activeTab, setActiveTab] = useState("Abroad Counseling");
  const [showMobileDropdown, setShowMobileDropdown] = useState(false);
  const [abroadServices, setAbroadServices] = useState([]);
  const [testPrepServices, setTestPrepServices] = useState([]);
  const [careerCounselingServices, setCareerCounselingServices] = useState([]);
  const [otherServices, setOtherServices] = useState([]);
  const [profileBuildingServices, setProfileBuildingServices] = useState([]);
  const [coreserviceId, setCoreServiceId] = useState([]);
  const [coreServices, setCoreServices] = useState([]);
  const dispatch = useDispatch();

  const services = [
    "Abroad Counseling",
    "Test Preparation",
    "Career Counseling",
    "Other Services",
    "Profile Building",
  ];

  const serviceLabels = {
    "Abroad Counseling": "Abroad",
    "Test Preparation": "Test Prep",
    "Career Counseling": "Career",
    "Other Services": "Other",
    "Profile Building": "Profile",
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        if (activeTab === "Abroad Counseling") {
          const data = await getAbroadCounselingServices();
          setAbroadServices(data);
        } else if (activeTab === "Test Preparation") {
          const data = await getTestPreparationServices();
          setTestPrepServices(data);
        } else if (activeTab === "Career Counseling") {
          const data = await getCareerCounselingServices();
          setCareerCounselingServices(data);
        } else if (activeTab === "Other Services") {
          const data = await getOtherServices();
          setOtherServices(data);
        } else if (activeTab === "Profile Building") {
          const data = await getProfileBuildingServices();
          setProfileBuildingServices(data);
        }
      } catch (error) {
        console.error("Error fetching services", error);
      }
    };

    fetchServices();
  }, [activeTab]);

  // Add a new service row based on the active tab
  const addNewService = () => {
    let newService;
    switch (activeTab) {
      case "Abroad Counseling":
        newService = {
          id: Date.now(),
          name: "",
          country: "",
          price: "",
          level_of_study: "",
          coreservices_id: "",
          selected: false,
          isNew: true,
        };
        setAbroadServices([
          ...abroadServices,
          { ...newService, id: abroadServices.length + 1 },
        ]);
        break;

      case "Test Preparation":
        newService = {
          id: Date.now(),
          exam_name: "",
          price_for_one: "",
          price_for_three: "",
          private_coaching_price: "",
          coreservices_id: "",
          selected: false,
          isNew: true,
        };
        setTestPrepServices([
          ...testPrepServices,
          { ...newService, id: testPrepServices.length + 1 },
        ]);
        break;

      case "Career Counseling":
        newService = {
          id: Date.now(),
          service_name: "",
          price: "",
          coreservices_id: "",
          selected: false,
          isNew: true,
        };
        setCareerCounselingServices([
          ...careerCounselingServices,
          { ...newService, id: careerCounselingServices.length + 1 },
        ]);
        break;

      case "Other Services":
        newService = {
          id: Date.now(),
          service_name: "",
          price: "",
          coreservices_id: "",
          selected: false,
          isNew: true,
        };
        setOtherServices([
          ...otherServices,
          { ...newService, id: otherServices.length + 1 },
        ]);
        break;

      case "Profile Building":
        newService = {
          id: Date.now(),
          service_name: "",
          price: "",
          coreservices_id: "",
          selected: false,
          isNew: true,
        };
        setProfileBuildingServices([
          ...profileBuildingServices,
          { ...newService, id: profileBuildingServices.length + 1 },
        ]);
        break;

      default:
        console.error("Invalid tab");
        break;
    }
  };

  useEffect(() => {
    fetchCore();
  }, []);

  useEffect(() => {
    const selectedCoreService = coreServices.find(
      (coreService) => coreService.core_service_name === activeTab
    );
    if (selectedCoreService) {
      setCoreServiceId(selectedCoreService.id);
    }
  }, [activeTab, coreServices]);

  const fetchCore = async () => {
    try {
      const data = await getNewTable();
      setCoreServices(data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteAbroadService = async (id) => {
    try {
      await deleteAbroadCounselingService(id);
      loadAbroadServices();
    } catch (error) {
      console.error("Error deleting abroad counseling service", error);
    }
  };

  const handleDeleteTestPreparation = async (id) => {
    try {
      await deleteTestPreparationService(id);
      loadTestPrepServices();
    } catch (error) {
      console.error("Error deleting test preparation service", error);
    }
  };

  const handleDeleteCareerCounciling = async (id) => {
    try {
      await deleteCareerCounselingService(id);
      loadCareerServices();
    } catch (error) {
      console.error("Error deleting career counseling service", error);
    }
  };

  const handleDeleteOtherServices = async (id) => {
    try {
      await deleteOtherService(id);
      loadOtherServices();
    } catch (error) {
      console.error("Error deleting other service", error);
    }
  };

  const handleDeleteProfileBulildingServices = async (id) => {
    try {
      await deleteProfileBulldingService(id);
      loadProfileBuildingServices();
    } catch (error) {
      console.error("Error deleting profile building service", error);
    }
  };

  // Handle tab selection
  const handleTabSelect = (service) => {
    setActiveTab(service);
    setShowMobileDropdown(false);
  };

  // Render content based on active tab
  const renderContent = () => {
    switch (activeTab) {
      case "Abroad Counseling":
        return (
          <AbroadTable
            services={abroadServices}
            setServices={setAbroadServices}
            coreServiceId={coreserviceId}
            saveService={handleSaveAbroadService}
            deleteService={handleDeleteAbroadService}
          />
        );
      case "Test Preparation":
        return (
          <TestPrepTable
            services={testPrepServices}
            setServices={setTestPrepServices}
            coreServiceId={coreserviceId}
            saveTestPrepServices={saveTestPrepServices}
            deleteService={handleDeleteTestPreparation}
          />
        );
      case "Career Counseling":
        return (
          <CareerCounselingTable
            services={careerCounselingServices}
            setServices={setCareerCounselingServices}
            coreServiceId={coreserviceId}
            saveCareerCouncilingServices={saveCareerCouncilingServices}
            deleteService={handleDeleteCareerCounciling}
          />
        );
      case "Other Services":
        return (
          <OtherServicesTable
            services={otherServices}
            setServices={setOtherServices}
            coreServiceId={coreserviceId}
            saveOtherServices={saveOtherServices}
            deleteService={handleDeleteOtherServices}
          />
        );
      case "Profile Building":
        return (
          <ProfileBuildingTable
            coreServiceId={coreserviceId}
            services={profileBuildingServices}
            setServices={setProfileBuildingServices}
            saveProfileBuildingServices={saveProfileBuildingServices}
            deleteService={handleDeleteProfileBulildingServices}
          />
        );
      default:
        return <p className="text-gray-700">Currently viewing: {activeTab}</p>;
    }
  };

  const loadProfileBuildingServices = async () => {
    try {
      const data = await getProfileBuildingServices();
      dispatch(setServices({ profile_building_list: data }));
      setProfileBuildingServices(data);
    } catch (error) {
      console.error("Error fetching Profile Building Services", error);
    }
  };

  const loadOtherServices = async () => {
    try {
      const data = await getOtherServices();
      dispatch(setServices({ other_services_list: data }));
      setOtherServices(data);
    } catch (error) {
      console.error("Error fetching Other Services", error);
    }
  };

  const loadCareerServices = async () => {
    try {
      const data = await getCareerCounselingServices();
      dispatch(setServices({ career_counselling_list: data }));
      setCareerCounselingServices(data);
    } catch (error) {
      console.error("Error fetching Career Counseling Services", error);
    }
  };

  const loadTestPrepServices = async () => {
    try {
      const data = await getTestPreparationServices();
      dispatch(setServices({ test_prep_list: data }));
      setTestPrepServices(data);
    } catch (error) {
      console.error("Error fetching Test Preparation Services", error);
    }
  };

  const loadAbroadServices = async () => {
    try {
      const data = await getAbroadCounselingServices();
      dispatch(setServices({ abroad_counselling_list: data }));
      setAbroadServices(data);
    } catch (error) {
      console.error("Error fetching abroad counseling services", error);
    }
  };

  const handleSaveAbroadService = async (service) => {
    try {
      if (!service.service_name || service.service_name.trim() === "") {
        console.error("Service name is required but missing!");
        return;
      }

      await createAbroadCounselingService({
        ...service,
        service_name: service.service_name,
        country: service.country,
        price: service.price,
        level_of_study: service.level_of_study,
        coreservices_id: service.coreservices_id,
      });

      loadAbroadServices();
    } catch (error) {
      console.error(
        "Error creating abroad counseling service:",
        error.response?.data || error.message
      );
    }
  };

  const saveTestPrepServices = async (service) => {
    try {
      if (!service.exam_name || service.exam_name.trim() === "") {
        console.error("Service name is required but missing!");
        return;
      }

      await createTestPreparationService({
        exam_name: service.exam_name,
        price_for_one: service.price_for_one,
        price_for_three: service.price_for_three,
        private_coaching_price: service.private_coaching_price,
        additional_notes: service.additional_notes,
      });

      loadTestPrepServices();
    } catch (error) {
      console.error(
        "Error creating Test Preparation service:",
        error.response?.data || error.message
      );
    }
  };

  const saveCareerCouncilingServices = async (service) => {
    try {
      if (!service.service_name || service.service_name.trim() === "") {
        console.error("Service name is required but missing!");
        return;
      }

      await createCareerCounselingService({
        ...service,
        service_name: service.service_name,
        price: service.price,
        country: service.country,
        level_of_study: service.level_of_study,
        coreservices_id: service.coreservices_id,
      });

      loadCareerServices();
    } catch (error) {
      console.error(
        "Error creating Career Counseling service:",
        error.response?.data || error.message
      );
    }
  };

  const saveOtherServices = async (service) => {
    try {
      if (!service.service_name || service.service_name.trim() === "") {
        console.error("Service name is required but missing!");
        return;
      }

      await createOtherService({
        ...service,
        service_name: service.service_name,
        price: service.price,
        country: service.country,
        level_of_study: service.level_of_study,
        coreservices_id: service.coreservices_id,
      });

      loadOtherServices();
    } catch (error) {
      console.error(
        "Error creating Other service:",
        error.response?.data || error.message
      );
    }
  };

  const saveProfileBuildingServices = async (service) => {
    try {
      if (!service.service_name || service.service_name.trim() === "") {
        console.error("Service name is required but missing!");
        return;
      }

      await createProfileBuildingService({
        ...service,
        service_name: service.service_name,
        price: service.price,
        country: service.country,
        level_of_study: service.level_of_study,
        coreservices_id: service.coreservices_id,
      });

      loadProfileBuildingServices();
    } catch (error) {
      console.error(
        "Error creating Profile Building service:",
        error.response?.data || error.message
      );
    }
  };

  return (
    <div
      className={`flex-1 bg-white ${
        isSideBarOpen ? "sm:ml-80" : "sm:ml-20"
      } min-h-screen`}
    >
      <div className="p-3 sm:p-6 bg-white rounded-lg shadow-md max-w-full mx-auto">
        <h1 className="text-xl sm:text-2xl font-semibold mb-4">
          Services & Pricing
        </h1>

        {/* Mobile Dropdown Tabs (visible on small screens) */}
        <div className="block sm:hidden mb-4">
          <div className="relative">
            <button
              onClick={() => setShowMobileDropdown(!showMobileDropdown)}
              className="w-full flex items-center justify-between px-4 py-3 bg-white border border-gray-200 rounded-lg shadow-sm"
            >
              <span className="font-medium text-gray-700">
                {serviceLabels[activeTab] || activeTab}
              </span>
              <FaChevronDown
                className={`transition-transform duration-200 ${
                  showMobileDropdown ? "rotate-180" : ""
                }`}
              />
            </button>

            {/* Mobile Dropdown Menu */}
            {showMobileDropdown && (
              <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                {services.map((service) => (
                  <button
                    key={service}
                    onClick={() => handleTabSelect(service)}
                    className={`
                      w-full text-left px-4 py-3 border-b border-gray-100 last:border-b-0
                      ${
                        activeTab === service
                          ? "bg-purple-50 text-purple-700"
                          : "text-gray-700 hover:bg-gray-50"
                      }
                    `}
                  >
                    {service}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Desktop Tabs (hidden on small screens) */}
        <div className="hidden sm:block mb-4">
          <div className="flex flex-wrap justify-center lg:justify-start">
            <div className="flex flex-wrap gap-1 bg-white shadow-md rounded-lg p-1">
              {services.map((service) => (
                <button
                  key={service}
                  onClick={() => handleTabSelect(service)}
                  className={`px-3 md:px-4 py-3 text-xs md:text-sm font-medium rounded-md transition-colors whitespace-nowrap ${
                    activeTab === service
                      ? "bg-purple-700 text-white"
                      : "text-gray-600 hover:bg-gray-100"
                  }`}
                >
                  <span className="hidden md:inline">{service}</span>
                  <span className="md:hidden">{serviceLabels[service]}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Add Row Button */}
        <div className="flex justify-end mb-4">
          <button
            onClick={addNewService}
            className="bg-green-400 hover:bg-green-500 text-white py-2 px-3 md:px-4 rounded-md flex items-center text-sm md:text-base transition-colors"
          >
            <FaPlus className="mr-1 md:mr-2" />
            <span className="hidden sm:inline">Add a Row</span>
            <span className="sm:hidden">Add</span>
          </button>
        </div>

        {/* Table section */}
        <div className="overflow-x-auto bg-white rounded-lg">
          {renderContent()}
        </div>
      </div>

      {/* Overlay to close mobile dropdown when clicking outside */}
      {showMobileDropdown && (
        <div
          className="fixed inset-0 z-40 sm:hidden"
          onClick={() => setShowMobileDropdown(false)}
        />
      )}
    </div>
  );
};

export default ServicesTab;
